/**
 * Знак программы: точечный узор, зеркальный по горизонтали.
 *
 * Из хэша, а не случайно: у программы всегда один и тот же знак, и его
 * узнаёшь в списке раньше, чем прочитаешь название — «Муж средний спец плечи»
 * и «...руки-плечи» глазом по тексту почти не различить.
 */
export function identicon(seed: string, size = 5): boolean[] {
  // FNV-1a и перемешивание хвоста: соседние названия дают несхожие узоры.
  let h = 2166136261;
  for (const ch of seed) {
    h ^= ch.codePointAt(0)!;
    h = Math.imul(h, 16777619);
  }
  h ^= h >>> 13;
  h = Math.imul(h, 0x5bd1e995);
  h ^= h >>> 15;

  const half = Math.ceil(size / 2);
  const cells = new Array<boolean>(size * size).fill(false);
  let bit = 0;
  for (let r = 0; r < size; r++) {
    for (let c = 0; c < half; c++) {
      const on = ((h >>> bit++) & 1) === 1;
      cells[r * size + c] = on;
      cells[r * size + (size - 1 - c)] = on;
    }
  }

  // Почти пустой знак не узнаётся — дорисовываем центральный столбец.
  if (cells.filter(Boolean).length < 7) {
    for (let r = 0; r < size; r++) cells[r * size + (half - 1)] = true;
  }
  return cells;
}
